import { render, staticRenderFns } from "./RelatorioModule.vue?vue&type=template&id=bcb90698"
import script from "./RelatorioModule.vue?vue&type=script&lang=js"
export * from "./RelatorioModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports